module.exports = __webpack_public_path__ + "e336917ad1ac7291502c5a6178c329e9.png";